import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from './Icon';

import styles from './pill/pill.module.scss';

export const Pill = (props) => {
  const { label, iconName, iconPosition, variant, className, removable, removeClicked, imgSource, imgAlt } = props;

  return (
    <div className={`_pill ${styles.pill} ${iconPosition === 'right' ? styles.right : ''} ${!iconName && imgSource ? styles.hasImg : ''} ${className} ${styles[variant]} ${removable ? styles.hasRemove : styles.noRemove}`}>
      {iconName && iconPosition === 'left' ? <Icon name={iconName} className={styles.iconLeft} /> : null}
      {!iconName && imgSource && iconPosition === 'left'
        ? (
          <div className={`${styles.imgContainerLeft} ${styles.imgContainer}`}>
            <img src={imgSource} alt={imgAlt} className={styles.img} />
          </div>
        )
        : null
      }
      {label}
      {removable ? (
        <span className={styles.removeIconWrapper} onClick={removeClicked}>
          <Icon name="Close" className={styles.pillRemoveIcon} />
        </span>
      ) : null}
      {iconName && iconPosition === 'right' ? <Icon name={iconName} className={styles.iconRight} /> : null}
      {!iconName && imgSource && iconPosition === 'right'
        ? (
          <div className={`${styles.imgContainerRight} ${styles.imgContainer}`}>
            <img src={imgSource} alt={imgAlt} className={styles.img} />
          </div>
        )
        : null
      }
    </div>
  );
};

Pill.defaultProps = {
  className: '',
  variant: 'basic',
  removable: false,
  removeClicked: () => {},
  iconPosition: 'left'
};

Pill.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  iconName: PropTypes.string,
  variant: PropTypes.oneOf(['basic', 'link', 'success', 'success1', 'warning', 'danger', 'danger1', 'naked']),
  iconPosition: PropTypes.oneOf(['left', 'right']),
  removable: PropTypes.bool,
  removeClicked: PropTypes.func,
  imgSource: PropTypes.string,
  imgAlt: PropTypes.string,
};
